// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { localCurrencySettings } from '../../../../utils/constans';

const WorkOrderHaveExpenses = ({ fundsInfo }) => (
  <div className="form_section">
    <div className="field_column with_spacing">
      <div className="field_name">
        <label>Total Expenses</label>
      </div>
      <div className="field_value">
        {fundsInfo.expenses.toLocaleString('en-US', localCurrencySettings)}
      </div>
    </div>
  </div>
);

export default WorkOrderHaveExpenses;
